const PAID = ["trialing", "active", "past_due"];

export const userPlan = (u) => {
  if (!u) return "free";
  if (u.plan === "standard" || u.plan === "professional") return u.plan;
  if (PAID.includes(u.subscription?.status)) return u.subscription?.plan === "standard" ? "standard" : "professional";
  return u.premium === true && !u.plan ? "professional" : "free";
};

export const PLAN_INFO = {
  free: { name: "Gratuito", price: "0\u20ac", per: "per sempre", note: "Per iniziare a farti conoscere" },
  standard: { name: "Standard", price: "19,90\u20ac", per: "all'anno", note: "Un'unica soluzione annuale" },
  professional: { name: "Professional", price: "58,80\u20ac", per: "all'anno", note: "Un'unica soluzione annuale", best: true },
};

export const PLAN_FEATURES = [
  ["Foto visibili", "3 a caso", "fino a 5", "fino a 5"],
  ["Video in alta qualit\u00e0", "1", "fino a 2", "fino a 5"],
  ["Descrizione e sottocategorie visibili", false, true, true],
  ["Badge \"Abilitato MePA\" (con prova di abilitazione Consip)", true, true, true],
  ["Chat con i committenti", false, true, true],
  ["Calendario visibile ai committenti", false, true, true],
  ["Preventivo automatico e contratto firmato", false, true, true],
  ["Posizione nelle ricerche", "in fondo", "sopra i gratuiti", "prioritaria"],
  ["Statistiche profilo", false, "visualizzazioni", "complete"],
  ["Risposta alle recensioni", false, false, true],
  ["Newsletter mensile ai Comuni", false, false, true],
  ["Indicizzazione sui motori di ricerca", false, false, true],
];
